'use strict';

require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");
require('../../company/checklist/CompanyChecklistService.js');

function CompanyGuestNotesDetailCtrl(
  $scope,
  publication,
  children,
  checklists,
  translations,
  $stateParams,
  $state,
  CompanyPublicationService,
  $sce,
  config,
  activityService
) {
  $scope.publication = publication;
  $scope.translations = translations;
  $scope.children = children;
  $scope.checklists = checklists;
  $scope.activityService = activityService;

  $scope.setDefaultColor = function() {
    $scope.children.forEach(function(c, i){
      if (!c.category) {
        $scope.children[i].category = {};
        $scope.children[i].category.color = 4279856278; // #196c96
      }
    });
  };

  $scope.setDefaultColor();

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/notes/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

}

CompanyGuestNotesDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
    return checklistService.query({
      companyId: $stateParams.companyId,
      relativeID: $stateParams.publicationId
    }).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  children: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 20}).$promise;
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestNotesDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestNotesDetailCtrl', [
  '$scope',
  'publication',
  'children',
  'checklists',
  'translations',
  '$stateParams',
  '$state',
  'CompanyPublicationService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestNotesDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/notes/CompanyGuestNotesDetailCtrl.js
// module id = 295
// module chunks = 0